// Величины графика и коридор нормы.

import type { ChartBand } from '@/components/charts/TimeSeriesChart'

import { NORM_KEYS, type NormKey, type ScanField, type ScanOut } from '../api'

/** 12 величин на выбор; у девяти из них есть норма в отчёте. */
export const CHART_FIELDS: readonly ScanField[] = [
  'weight_kg',
  'skeletal_muscle_kg',
  'body_fat_pct',
  'body_fat_kg',
  'fat_free_mass_kg',
  'total_body_water_l',
  'protein_kg',
  'minerals_kg',
  'visceral_fat_level',
  'bmi',
  'bmr_kcal',
  'score',
]

export function bandFor(field: ScanField, latest: ScanOut | null): ChartBand | null {
  if (!latest || !(NORM_KEYS as readonly string[]).includes(field)) return null
  const norm = latest.norms?.[field as NormKey]
  return norm ? { low: norm.low, high: norm.high, label: 'Норма' } : null
}
